
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Linkedin } from "lucide-react";

export const LinkedInAuth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleLinkedInAuth = async () => {
    setIsLoading(true);
    try {
      // Get current URL parameters to preserve them
      const redirectUrl = new URL(window.location.href);
      const orgId = searchParams.get('org');
      const inviteCode = searchParams.get('invite');
      
      // Build redirect URL with preserved parameters
      let finalRedirectUrl = `${window.location.origin}/auth`;
      if (orgId && inviteCode) {
        finalRedirectUrl = `${window.location.origin}/team/join?org=${orgId}&invite=${inviteCode}`;
      }

      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'linkedin_oidc',
        options: {
          redirectTo: finalRedirectUrl,
          scopes: 'openid profile email'
        }
      });

      if (error) {
        throw error;
      }

      // The user will be redirected to LinkedIn, then back to our app
    } catch (error: any) {
      console.error('LinkedIn auth error:', error);
      toast({
        title: "Authentication Failed",
        description: error.message || "Failed to authenticate with LinkedIn",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleLinkedInAuth}
      disabled={isLoading}
      className="w-full flex items-center gap-2"
    >
      <Linkedin className="h-4 w-4" />
      {isLoading ? "Connecting..." : "Continue with LinkedIn"}
    </Button>
  );
};
